export default console.log;